import request from '@/utils/request'



export function api_downloadapp(){
  return request({
    url: 'https://szone-api.7net.cc/index/appVersion',
    method: 'get',
    data: {
      platform:'android',
    }
  })
}

// 根据openid 获取 token
export function api_openidToken(openId){

    return request({
      url: '/publicszoneui.service/loginservice/LoginByOpenId',
      method: 'post',
      data: {
        openId,
      }
    })
}

//根据code 获取 openId 和 token
export function api_codeToken(code){
    return request({
      url: '/publicszoneui.service/loginservice/LoginByCode',
      method: 'post',
      data: {
        code,
      }
    })
}

export function api_area(){
  return request({
    url: 'https://static.7net.cc/common/area.js',
    method: 'get',
    data: {
    }
  })
}

//取消授权
export function api_cancelBind(data){
  return request({
    url:'/publicszoneui.service/LoginService/UnBindWX',
    method: 'post',
    data
  })
}

//取消授权
export function api_isWXBind(){
  return request({
    url:'/publicszoneui.service/LoginService/IsBindWX',
    method: 'post',
    data:{type:1}
  })
}


//获取用户信息
export function api_userInfo(token){
  return request({
    url: '/publicszoneui.service/UserService/info',
    method: 'post',
    data: {
      token,
    }
  })
}

//获取微信签名
export function api_wxSign(data){
  return request({
    url: '/publicszoneui.service/WX/WxSign',
    method: 'post',
    noToken: true,
    data
  })
}

//绑定学生信息
export function api_bindStudent(studentName,schoolGuid,cityCode,gradeCode,token){
  return request({
    url: '/publicszoneui.service/UserService/BindStudent',
    method: 'post',
    data: {
      studentName,schoolGuid,cityCode,gradeCode,token
    }
  })
}

//考试列表
export function api_examlist(studentName,schoolGuid,startIndex,rows,grade,token){
  return request({
    url: '/publicszoneui.service/ExamService/ClaimExams',
    method: 'post',
    data: {
      studentName,schoolGuid,startIndex,rows,token,grade
    }
  })
}

//获取验证码
export function api_sendSms(userCode){ //userCode 手机号
  return request({
    url: '/publicszoneui.service/LoginService/SendSMS',
    method: 'post',
    data: {
      userCode
    }
  })
}

//验证码登录
export function api_loginSms(userCode,verifyCode,token,openId){ //userCode 手机号
  return request({
    url: '/publicszoneui.service/LoginService/Entry',
    method: 'post',
    data: {
      userCode,verifyCode,token,openId
    }
  })
}

//验证码登录
export function api_loginPwd(userCode,userPass,openId){ //userCode 手机号
  return request({
    url: '/publicszoneui.service/loginservice/Login',
    method: 'post',
    noToken: true,
    data: {
      userCode,userPass,openId
    }
  })
}

//获取学校列表
export function api_bindSchool(cityCode,schoolName,token){ //userCode 手机号
  return request({
    url: '/publicszoneui.service/SchoolService/List',
    method: 'post',
    data: {
      cityCode,schoolName,token
    }
  })
}
